import { doc, runTransaction } from "firebase/firestore";

import { db, auth } from "../firebase/config";

export const generateMemberId = async () => {
  const gymId = auth.currentUser?.uid;

  if (!gymId) {
    throw new Error("User is not authenticated");
  }

  const counterRef = doc(db, "gyms", gymId, "memberCounter", "data");

  const memberId = await runTransaction(db, async (transaction) => {
    const counterSnap = await transaction.get(counterRef);

    let nextNumber = 1;

    if (counterSnap.exists()) {
      nextNumber = Number(counterSnap.data().lastNumber || 0) + 1;
    }

    transaction.set(
      counterRef,
      {
        lastNumber: nextNumber,
      },
      { merge: true },
    );

    return `MEM-${String(nextNumber).padStart(6, "0")}`;
  });

  return memberId;
};
